import baseAPIAction from "REDUX/BaseAPIAction";
import { API } from "CONSTANTS/AppConstants";
import { Strings } from "INTL/i18n";
import { API_RESPONSE_STATUS_CODE } from "../../../config/axios.init";

export default function getPaymentDetails(
  token,
  getPaymentDetailsActionCallback
) {
  const API_Call_Details = API.getPaymentDetails + token;

  return function(dispatch) {
    const config = {};
    baseAPIAction(API_Call_Details, getPaymentDetailsAPICallback, config);

    function getPaymentDetailsAPICallback(errorMessage, responseData) {
      if (errorMessage === "") {
        if (responseData.status !== API_RESPONSE_STATUS_CODE.SUCCESS) {
          if (responseData.status === API_RESPONSE_STATUS_CODE.TOKEN_EXPIRED)
            errorMessage = Strings("tokenExpiredMakeNewRequest");
          else if (
            responseData.status === API_RESPONSE_STATUS_CODE.TOKEN_NOT_FOUND
          )
            errorMessage = Strings("tokenNotFound");
          else if (
            responseData.status ===
            API_RESPONSE_STATUS_CODE.TOKEN_ALREADY_PROCESSED
          )
            errorMessage = Strings("tokenAlreadyProcessed");
          else if (
            responseData.status ===
            API_RESPONSE_STATUS_CODE.MAXIMUM_RETRY_ATTEMPTS_REACHED
          )
            errorMessage = Strings("maximumRetryAttemptReached");
          else errorMessage = Strings("internalError");
        }
      }
      getPaymentDetailsActionCallback(errorMessage, responseData);
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/Payer/actions/GetPaymentDetails.js